import { useContext } from 'react'

import { Card, Loading, TimeLineEvents, ToastContext } from '@reveni-io/reveni-ui'

import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useCustomLogisticsLabel from '@/common/hooks/useCustomLogisticsLabel/useCustomLogisticsLabel'
import useTimeLineComment from '@/common/hooks/useTimeLineComment/useTimeLineComment'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'
import returnsServices from '@/returns/services/services'

const TransactionTimeLineCard = ({ timeline, timelineLoading, data, fetchTimeline, onEmailNotificationClick }) => {
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const { loading, onDeleteTimelineImage, onSelectTimelineImages, sendTimelineComment, users, selectedTimelineImages } =
    useTimeLineComment({
      fetchTimeline,
      storeId: data?.store_id,
      resourceId: data?.id,
      setToastInfo,
      sendCommentService: returnsServices.sendComment,
      uploadProductImageService: returnsServices.uploadProductImage,
    })
  const { hasPermission } = useUserPermissions()
  const customLogisticsLabel = useCustomLogisticsLabel()

  return (
    <Card showBorder={false}>
      <Loading show={loading}>
        <TimeLineEvents
          source="returns"
          timeline={timeline}
          loading={timelineLoading}
          transactionType={data?.transaction_type}
          refundMethod={data?.refund_info?.refund_method}
          onSubmit={hasPermission(userPermissions.editReturnStatus, data?.store_id) ? sendTimelineComment : null}
          isInstant={data?.is_instant}
          onSelectImages={onSelectTimelineImages}
          selectedImages={selectedTimelineImages}
          onDeleteImage={onDeleteTimelineImage}
          userImage={info?.userInfo?.profile_picture_url}
          resourceLineItems={data?.line_items}
          timezone={info?.selectedStore.timezone}
          currentUser={info?.userInfo}
          atValues={users?.results?.map(u => ({
            id: u.id,
            value: u.username,
            first_name: u.first_name,
            last_name: u.last_name,
            profile_picture_url: u.profile_picture_url,
          }))}
          customLogisticsLabel={customLogisticsLabel}
          onEmailNotificationClick={onEmailNotificationClick}
        />
      </Loading>
    </Card>
  )
}

export default TransactionTimeLineCard
